export const deviation = (deviationSeconds) => {
    const deviationMinutes = Math.abs(Math.floor(deviationSeconds / 60))
    if (deviationMinutes === 0) {
        return 'On Time'
    }
    if (deviationMinutes === 1) {
        return '1 min'
    }
    if (deviationMinutes > 999) {
        return '1 day'
    }
    return `${deviationMinutes} mins`
}
